import React, {Component} from 'react'

import Screen from '../ui/Screen'
// import ErrorMessageDialog from '../ui/ErrorMessageDialog.js'

import ControlPanel from './OutcomeScreen/ControlPanel.js'

import OutcomeList from './OutcomeScreen/OutcomeList.js'
import SearchPanel from './OutcomeScreen/SearchPanel.js'

import ShowCommentDialog from './OutcomeScreen/ShowCommentDialog.js'

import Cookie from "../Cookie"
import {config} from "../config"

class OutcomeScreen extends Component {

  state = {
    search: '',
    items: [],
    itemsPerPage: 10,
    itemsAmount: 100,
    page: 0,
    dialog: null,
  }

  constructor(props) {
    super(props)
    this.handleChangePage = this.handleChangePage.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handleOutcomeListClickItem = this.handleOutcomeListClickItem.bind(this)
    this.handle_sortByDate = this.handle_sortByDate.bind(this)
  }

  getOutcome() {
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest()
      let first = this.state.page * this.state.itemsPerPage
      let amount = this.state.itemsPerPage

      let orderByDateString = (order => {
        if (order) {
          return `&orderByDate=${order}`
        } else {
          return ''
        }
      })(this.state.orderByDate)

      xhr.open("GET", config.restApiHost + `/acc/balance/outcome?sid=${Cookie.get("sid")}&first=${first}&amount=${amount}&search=${encodeURI(this.state.search)}${orderByDateString}`, true)
      xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
            let json = JSON.parse(xhr.responseText)
            resolve(json)
          } else {
            reject("Не удалось получить список списания")
          }
        }
      }
      xhr.send()
    })
  }

  update() {
    return new Promise((resolve, reject) => {
      this.getOutcome().then(outcome => {
        this.setState({
          items: outcome.items,
          itemsAmount: outcome.itemsAmount,
        })
        resolve(outcome)
      }, reject)
    })
  }

  componentDidMount() {
    this.update()
  }

  handleSearch(search) {
    this.setState({
      search: search
    }, this.update)
  }

  handleChangePage(page) {
    this.setState({
      page: page,
    }, this.update)
  }

  handleOutcomeListClickItem(item) {
    this.setState({
      dialog: <ShowCommentDialog
        comment = {item.comment}
        onClose = {() => {
          this.setState({
            dialog: null,
          })
        }}
      />
    })
  }

  /**
   * Обработка нажатия на кнопку сортироки по дате.
   * @param order - текущий порядок сортировки.
   */

  handle_sortByDate(order) {
    let newOrder = (order => {
      switch (order) {
        case 'ASC':
          return 'DESC'
        case 'DESC':
          return undefined
        default:
          return 'ASC'
      }
    })(order)
    this.setState({
      orderByDate: newOrder
    }, this.update)
  }

  render() {
    return <Screen>

      {this.state.dialog}

      <ControlPanel
        order = {this.state.orderByDate}
        onSrotByDateClick = {this.handle_sortByDate}
      />

      <SearchPanel
        onChange = {this.handleSearch}
      />

      <OutcomeList
        items = {this.state.items}
        itemsAmount = {this.state.itemsAmount}
        itemsPerPage = {this.state.itemsPerPage}
        page = {this.state.page}
        onChangePage = {this.handleChangePage}
        onClickItem = {this.handleOutcomeListClickItem}
      />

    </Screen>
  }

}

export default OutcomeScreen
